'use strict';

const forEach = require('lodash/forEach');

var robust = require('../util/robust');
var toggle = require('../modules/toggle');
var spotlight = require('../modules/spotlight');
var accordion = require('../modules/accordion');
var videoResize = require('../modules/videoResize');
var inlineGallery = require('../modules/inlineGallery');
var wow = require('../modules/wow');
var skrollrReplacement = require('../modules/skrollr-replacement');
var dragscroll = require('../modules/dragscroll');
var fovScheduleDays = require('../modules/fovScheduleDays');
var header = require('../modules/header');
var headerCarousel = require('../modules/headerCarousel');
var audioPlayer = require('../modules/audioPlayer');
var scrollTo = require('../modules/scroll-to');
var messages = require('../modules/messages');
var languageMessage = require('../modules/languageMessage');
var pageHeroVideo = require('../modules/pageHeroVideo');
var detailsAccordion = require('../modules/detailsAccordion');
var newsSignupModal = require('../modules/newsSignupModal');
var productionOverlay = require('../modules/productionOverlay');
var tabs = require('../modules/tabs');
var popupGallery = require('../modules/popupGallery');
var scroller = require('../modules/scroller');
var popupVideo = require('../modules/popupVideo');

function init() {
    var modules = robust
        .defineModules([
            ['toggle', toggle.init],
            ['spotlight', spotlight.init],
            ['accordion', accordion.init],
            ['videoResize', videoResize.init],
            ['inlineGallery', inlineGallery.init],
            ['wow', wow.init],
            ['skrollr-replacement', skrollrReplacement.init],
            ['dragscroll', dragscroll.init],
            ['fovScheduleDays', fovScheduleDays.init],
            ['header', header.init],
            ['headerCarousel', headerCarousel.init],
            ['audioPlayer', audioPlayer.init],
            ['scrollTo', scrollTo.init],
            ['messages', messages.init],
            ['languageMessage', languageMessage.init],
            ['pageHeroVideo', pageHeroVideo.init],
            ['detailsAccordion', detailsAccordion.init],
            ['newsSignupModal', newsSignupModal.init],
            ['productionOverlay', productionOverlay.init],
            ['tabs', tabs.init],
            ['popupGallery', popupGallery.init],
            ['scroller', scroller.init],
            ['popupVideo', popupVideo.init]
        ]);

    forEach(modules, function(module) {
        module();
    });
}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./bootstraps/common.js